<template>
  <div class="container-right_sidebar">
    <!-- <p  class="section-label">
      {{ $t("ticket.roomInformation") }}
    </p> -->
    <p v-if="!ticketStore.isChatMeTicket" class="section-label">
      {{ $t("ticket.visitor_info") }}
    </p>

    <div style="display: grid; gap: 1em">
      <div class="tab-container">
        <b-tabs content-class="mt-0">
          <b-tab v-for="(profile, index) in ticketStore.selectedChatMeTicketDetail
            .filterRoom" :key="profile.id" :title="profile.meta.name" :active="index == 0 ? true : false">
            <div class="tree-node accordion" role="tablist">
              <div no-body class="mb-0">
                <div header-tag="header" variant="info">
                  <div class="personal-info pt-0" style="width: 100%">
                    <div class="list-unstyled mb-2">
                      <!--Visitor Section-->
                      <!-- <h6 class="section-label mb-2">
                        {{ $t("general.profileInfo") }}
                      </h6> -->
                      <div style="display: grid; gap: 1em">
                        <EditableLabel icon="HashIcon" :default-data="profile.meta.id ? profile.meta.id : $t('ticket.na')" />

                        <EditableLabel icon="UserIcon" :default-data="profile.meta.name ? profile.meta.name : $t('ticket.na')" />

                        <EditableLabel icon="MapPinIcon" placeholder="Enter Name" :default-data="profile.meta.timezone ? profile.meta.timezone : $t('ticket.na')" />

                        <EditableLabel icon="MonitorIcon" placeholder="Enter Name" :default-data="profile.meta.device ? profile.meta.device : $t('ticket.na')" />

                        <EditableLabel icon="StopCircleIcon" placeholder="Enter Name" :default-data="profile.meta.ip ? profile.meta.ip : $t('ticket.na')" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>

    </div>
  </div>
</template>
<script>
import useTicketStore from "@/store-pinia/useTicketStore";
import { ref, watch, onMounted, computed } from "@vue/composition-api";
import CustomerRepository from "@/repositories/Api/CustomerRepository";
import EditableLabel from "@/components/global-components/EditableLabel.vue";
import { BCard, BTab, BTabs, BCardHeader, BCardBody } from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    BCardHeader,
    BCardBody,
    BTab,
    BTabs,
    BCard,
    EditableLabel,
  },
  props: {
    roomId: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const ticketStore = useTicketStore();

    const nameForm = ref("");
    const emailForm = ref("");
    const phoneForm = ref("");
    const isEditName = ref(false);
    const isEditEmail = ref(false);
    const isEditPhone = ref(false);
    const roomInfo = ref([]);

    function handleSubmitUpdateProfile(payload) {
      CustomerRepository.updateCustomerProfile(
        { ...payload },
        ticketStore.getSelectedTicketDetailCustomerID
      )
        .then((response) => {
          console.log(response);
        })
        .then(() => {
          ticketStore.getTicketsAsync();
        });
    }

    function resetForm() {
      nameForm.value = "";
      emailForm.value = "";
      phoneForm.value = "";
    }

    function handleCloseEditProfile() {
      resetForm();
    }

    const userData = computed(() => {
      const storedData = localStorage.getItem(
        useJwt.jwtConfig.storageUserDataKeyName
      );
      return storedData ? JSON.parse(storedData) : null;
    });

    watch(
      () => props.roomId,
      (newValue, oldValue) => {
        if (newValue && props.isPrivateChat) {
          // roomInfo.value = ticketStore.getChatMeRoomInfo(newValue, userData.value.id);
          console.log(
            ticketStore.getChatMeRoomInfo(newValue, userData.value.id)
          );
        }
      }
    );

    onMounted(() => {
      if (props.roomId) {
        console.log("props.roomId>>>", props.roomId);
        console.log(
          ticketStore.getChatMeRoomInfo(props.roomId, userData.value.id)
        );
        roomInfo.value = ticketStore.getChatMeRoomInfo(
          props.roomId,
          userData.value.id
        );
      }
    });

    return {
      roomInfo,
      isEditName,
      isEditEmail,
      isEditPhone,
      ticketStore,
      nameForm,
      emailForm,
      phoneForm,
      resetForm,
      handleCloseEditProfile,
      handleSubmitUpdateProfile,
    };
  },
};
</script>

<style lang="scss" scoped>
.clickable-icon {
  cursor: pointer;
}

.label-container {
  display: flex;
  gap: 1em;
}

.container-right_sidebar {}
</style>
